import { DataFlowDetailsJson } from './dto';

const dataFlowDetailsJsonExample: DataFlowDetailsJson = {
	streams: [
		{
			direction: 'request',
			endpoint_id: 1010,
			host: 'analytics.acme.com',
			url: '/api/v1/orders/',
			method: 'GET',
			protocol: 'http',
			data_types: [1, 5],
			last_seen: 1653636900042,
			is_encrypted: false,
			is_mesh_network: false,
			estimated_requests: 387,
		},
	],
	data_types: [1, 5],
};

export { dataFlowDetailsJsonExample };
